module.exports = __webpack_public_path__ + "0868fef0758ae248193d68d1f54762ce.png";